module.exports = __webpack_public_path__ + "img/Coat_of_arms_of_Iraq.76275fc3.svg";